// extracted by mini-css-extract-plugin
var _1 = "active-OHtp";
var _2 = "#007ac9";
var _3 = "contentItem-vp7z";
var _4 = "contentList-I_cg";
var _5 = "#575757";
var _6 = "disabled-LYVo";
var _7 = "1.5rem";
var _8 = "#dedede";
var _9 = "#adf";
var _a = "1rem";
var _b = "#bebebe";
var _c = ".8rem";
var _d = "tab-HB2N";
var _e = "tabList-IwwV";
var _f = "tabs-QfCR";
var _10 = "#000";
export { _1 as "active", _2 as "busBlue", _3 as "contentItem", _4 as "contentList", _5 as "darkGrey", _6 as "disabled", _7 as "extraLargeFontSize", _8 as "lightGrey", _9 as "lightblue", _a as "mediumFontSize", _b as "mediumLightGrey", _c as "smallFontSize", _d as "tab", _e as "tabList", _f as "tabs", _10 as "unusedNodeColor" }
